import { Grid, useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';
import React, { FunctionComponent, Suspense } from 'react';
import {
  BG_PRIORITY,
  usePageBackgroundColor,
} from '../../core/contexte/backgroundColorContext';
import Loading from '../../core/componentLoading/loading';
import { PageColumn, PageLayout } from '../../core/formBuilder/usePages';
import ImageColumn from '../pageLayout/imageColumn';
import { ProcessColumn } from './processColumn';
import { useParams } from 'react-router-dom';
import { getTenantIdFromEnv } from '../../utils/tenantUtils';

interface PageLayoutContainerProps {
  pageLayout?: PageLayout;
  disableFormLayout?: boolean;
  customFormSpacing?: Record<string, number>;
  verticalContentAlignment?: string;
  backgroundColor?: string;
}

export const PageLayoutContainer: FunctionComponent<
  PageLayoutContainerProps
> = ({
  pageLayout,
  disableFormLayout,
  customFormSpacing,
  verticalContentAlignment,
  backgroundColor,
  children,
}) => {
  const { project } = useParams();
  const isPaybackAmexConfig =
    getTenantIdFromEnv() === 'payback' &&
    project?.toLowerCase().includes('amex'); // enable mobile layout on tablets for payback (amex configs)
  const isMobile = useMediaQuery((theme: Theme) =>
    theme?.breakpoints?.down(isPaybackAmexConfig ? 'md' : 'sm')
  );
  const matchesTablet = useMediaQuery((theme: Theme) =>
    theme.breakpoints.between('xs', 'md')
  );

  usePageBackgroundColor(backgroundColor, BG_PRIORITY.PAGE);

  return (
    <Suspense fallback={<Loading />}>
      <Grid container spacing={0}>
        {!pageLayout?.columns?.length || isMobile ? (
          <Grid item xs>
            <ProcessColumn
              pageHeader={pageLayout?.header}
              pageFooter={pageLayout?.footer}
              disableFormLayout={disableFormLayout}
              customFormSpacing={customFormSpacing}
              verticalContentAlignment={verticalContentAlignment}
            >
              {children}
            </ProcessColumn>
          </Grid>
        ) : (
          pageLayout.columns.map((column: PageColumn, i: number) => (
            <React.Fragment key={`page-layout-column-${i}`}>
              {column.type === 'process' ? (
                <Grid item xs>
                  <ProcessColumn
                    pageHeader={pageLayout?.header}
                    pageFooter={pageLayout?.footer}
                    disableFormLayout={disableFormLayout}
                    customFormSpacing={customFormSpacing}
                    verticalContentAlignment={verticalContentAlignment}
                  >
                    {children}
                  </ProcessColumn>
                </Grid>
              ) : column.type === 'image' ? (
                <Grid
                  sx={{
                    width: matchesTablet ? '33vw' : '50vw',
                    maxWidth: matchesTablet ? '33vw' : '50vw',
                  }}
                  item
                >
                  <ImageColumn column={column} />
                </Grid>
              ) : null}
            </React.Fragment>
          ))
        )}
      </Grid>
    </Suspense>
  );
};
